import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaFormatosGeneralesInterface } from "../../../../../interfaces/FechaFormatosGeneralesInterface";
import HeaderPrint from "../../../../../components/HeaderFormsPrint/HeaderFormsPrint";
import fotoMapa from "../../../../../img/fotoMapa.png";

export const ProtestaFotocopiasListaPrint = () => {
  const tituloFormulario = "PROTESTA PARA FOTOCOPIAS";
  const [formData, setFormData] = useState({
    day: "",
    month: "",
    year: "",
  });

  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const { reset } = useForm();

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFechaFG = useGetData<FechaFormatosGeneralesInterface>({
    url: `/fecha_formatosgenerales/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha_formatosgenerales"],
  });

  const navigate = useNavigate();

  useEffect(() => {
    if (queryFechaFG.data) {
      const fechafg = queryFechaFG.data;
      reset({
        fecha_inasistencia: fechafg.fecha_inasistencia || "",
      });
    }
  }, [queryFechaFG.data, reset]);

  return (
    <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden mt-4 mb-4 relative">
      {/* Header */}
      <HeaderPrint titulo={tituloFormulario} />
      {/* Título del formulario */}
      <div id="headerContent" className="text-center">
        <h1
          className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
          style={{
            backgroundImage: `url(${fotoMapa})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {tituloFormulario}
        </h1>
      </div>
      {/* Contenido del formulario */}
      <div className="p-6 flex flex-col gap-6">
        {/* Texto principal */}
        <p className="text-justify text-gray-800 leading-relaxed">
          Bajo protesta de decir verdad, hago constar que la presente fotocopia
          fue tomada del documento original, mismo que cuenta con validez
          oficial y fue expedido por una institución con reconocimiento
          gubernamental.
        </p>

        <p className="text-justify text-gray-800 leading-relaxed">
          Hago entrega a la empresa{" "}
          <strong>SKA TRACKING AND SECURITY S.A. de C.V.</strong> en la fecha:
          {queryFechaFG.data?.fecha_protesta_fotocopias
            ? (() => {
                const date = new Date(
                  queryFechaFG.data.fecha_protesta_fotocopias
                );
                date.setDate(date.getDate() + 1);
                return date.toLocaleDateString("es-ES", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                });
              })()
            : "Fecha no disponible"}
        </p>

        {/* Datos del Evaluado */}
        <div className="space-y-1 text-left">
          <h2 className="text-lg font-bold">{`NOMBRE: ${
            queryEvaluado.data?.nombre || ""
          } ${queryEvaluado.data?.apellido_paterno || ""} ${
            queryEvaluado.data?.apellido_materno || ""
          }`}</h2>
          <h2 className="text-lg font-bold">{`EMPRESA: ${queryEvaluado.data?.empresa_id.nombre}`}</h2>
          <h2 className="text-lg font-bold">{`PUESTO: ${
            queryEvaluado.data?.puesto || ""
          }`}</h2>
        </div>
      </div>

      {/* Firma */}
      <div className="pt-16 text-center">
        <div className="w-64 mx-auto border-t border-black pt-2">
          <p className="text-sm font-semibold">FIRMA</p>
        </div>
      </div>

      <div className="mt-[300px]"></div>

      {/* Footer */}
      <div className="bg-customBlue/90 py-2 rounded-b-lg w-full">
        <p className="text-white text-xs text-center font-light px-4">
          <span className="font-medium">DOCUMENTO CONFIDENCIAL</span> •
          Prohibida su reproducción o copia fuera de las instalaciones de
          Skyangel.
        </p>
      </div>
    </div>
  );
};
